// extracted by mini-css-extract-plugin
export default {"main":"ph0ARKWRcXlwvveFSwGW"};